import { EditMode } from "PFApp/booking/types/edit_mode";
import { BookingWithData } from "PFCore/hooks/queries/profile";
import { Id } from "PFTypes";
import { useCallback } from "react";

import { useEditMode } from "../booking_edit_mode_store";

export const useDraftOperation = (
  targetMode: EditMode,
  affectedBookingIds: Id[],
  transformer: (booking: BookingWithData) => BookingWithData | BookingWithData[]
) => {
  const editMode = useEditMode();

  const performDraftOperation = useCallback(
    (bookings: BookingWithData[]): BookingWithData[] => {
      const shouldBeUpdated =
        editMode === targetMode &&
        bookings.some((booking) => booking.id && affectedBookingIds.includes(booking.id));

      if (!shouldBeUpdated) {
        return bookings;
      }

      return bookings.flatMap((booking) => {
        if (booking.id && affectedBookingIds.includes(booking.id)) {
          const result = transformer(booking);
          return Array.isArray(result) ? result : [result];
        }
        return [booking];
      });
    },
    [editMode, targetMode, affectedBookingIds, transformer]
  );

  return performDraftOperation;
};
